import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c5b3c298"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "desc" }

import { ref, watch, computed } from 'vue'
import { t } from '@/plugins/i18n'
import { searchUploadProgressApi, orderExcelKnowApi } from '@/apis/shopcart'
import { getShopLogistics, AdtCfgList, getCustomerShopShipListApi } from '@/apis/setup'
import CheckSet from './CheckSet.vue'
import UploadFileModal from './uploadFileModal.vue' // 上传文件弹窗
import UploadProgress from './UploadProgress.vue' // 进度条
import UploadFail from './UploadFail.vue' // 下单失败弹窗
import UploadFailTable from './UploadFailTable.vue'
import OpenMember from './OpenMember.vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import { emit } from 'process'
import { useSourceCountry } from '../country'
import { getWarehouseCode } from '@/store'
import { COUNTRY } from '@/global'

export default /*#__PURE__*/_defineComponent({
  props: {
  // 0导入商品 1导入订单
  mode: {
    type: Number,
    default: 1
  },
  isCanUseOnTheWayStock: {
    type: Boolean,
    default: false
  }
},
  emits: ['success'],
  setup(__props, { emit: emits }) {

const props = __props
const route = useRoute()
const [val, change] = useSourceCountry()


const checkSetVisible = ref(false) // 配置附加项弹窗
const uploadFileModalVisible = ref(false) // 导入订单弹窗
const uploadFailVisible = ref(false)
const uploadFailTableVisible = ref(false)
const uploadProgressVisible = ref(true)
const isLoading = ref(false)
const tableFailType = ref(1) // 表格报错来源1 前端报错2后端报错
const taskId = ref('')
const store = useStore()
let timer: any = null

const taskType = ref(props.mode === 1 ? 1 : 2)
const setObj = ref({
  goodsAddition: false,
  deliverAddition: false,
  internationalExpress: false
})
const errorList = ref([])
const openMemberRef = ref()
const open = () => {
  if (store.getters.membership.templateLevel === 0) {
    openMemberRef.value.open()
    return
  }
  if (props.mode === 0) {
    // 导入商品
    uploadFileModalVisible.value = true
    return
  }
  // 判断是否配置
  Promise.all([getShopLogistics({ warehouseCode: getWarehouseCode(val.value === COUNTRY.KR) }), AdtCfgList({
    warehouseCode: getWarehouseCode(val.value === COUNTRY.KR)
  }), getCustomerShopShipListApi({ warehouseCode: getWarehouseCode(val.value === COUNTRY.KR) })]).then((res: any) => {
    const express = res[0].data
    const goods = res[1].data

    const goodsAddition = goods.some((item: any) => { return item.additionScene === 0 && (item.additionItemList.length > 0 || item.noAdditionalFlag === 1) })
    const deliverAddition = express?.additionItemList.length > 0
    const internationalExpress = res[2].data?.length > 0
    setObj.value = {
      goodsAddition,
      deliverAddition,
      internationalExpress
    }
    if (goodsAddition && deliverAddition && internationalExpress) {
      uploadFileModalVisible.value = true
    } else {
      // 未配置弹窗
      checkSetVisible.value = true
    }
  })
  // ******
}
const failInfo: any = ref({})
const getProgress = () => {
  searchUploadProgressApi({
    taskType: props.mode === 1 ? 1 : 2
  }).then((res: any) => {
    const { validFlag, knowFlag, taskStatus, messageList, totalQuantity, successQuantity } = res.data
    failInfo.value = res.data
    isLoading.value = false
    if (res.data.message) {
      ElMessage.warning(res.data.message)
      orderExcelKnowApi({
        taskId: res.data.taskId
      })
      return
    }
    if (validFlag === null && taskStatus === null) return
    if (validFlag === 0 || taskStatus === 1) {
      // 表格校验中
      isLoading.value = true
    }
    if (validFlag === 2) {
      // 校验失败
      uploadFailTableVisible.value = true
      errorList.value = sortList((messageList || []).map((i: any) => {
        return {
          ...i,
          rowNumber: i.line,
          error: i.message
        }
      }))
      tableFailType.value = 2
      taskType.value = res.data.taskType
      taskId.value = res.data.taskId
      return
    }
    if (taskStatus === 3 && knowFlag === 1) {
      // 导入失败 && 未知晓
      uploadFailVisible.value = true
      return
    }
    if (taskStatus === 1 && validFlag === 1) {
      // 表格处理中
      uploadProgressVisible.value = true
    }
    if ((validFlag === 0 || taskStatus === 1) && route.path.indexOf('shopcart') > -1) {
      // 校验或者处理中循环调用
      clearTimeout(timer)
      timer = setTimeout(() => {
        console.log(new Date().getTime())
        getProgress()
      }, 5000)
    }
    if (taskStatus === 2 && totalQuantity > 0 && totalQuantity === successQuantity && props.mode === 1) {
      orderExcelKnowApi({
        taskId: res.data.taskId
      })
      ElMessage.success(t('订单创建成功，完成付款后下单成功'))
    }
    if (taskStatus === 2 && props.mode === 0) {
      emits('success')
    }
  })
}

// 上传成功回调
const uploadSuccessCallback = () => {
  getProgress()
}
// 上传文件校验异常
const failCheckErrorCallback = (list: any, type:number) => {
  errorList.value = sortList(list)
  uploadFailTableVisible.value = true
  tableFailType.value = 1
  taskType.value = type
}

// 监听切换直发囤货重新调用查询表格上传状态
watch(() => props.mode, () => {
  clearTimeout(timer)
  getProgress()
}, { immediate: true })

const btnText = computed(() => {
  if (props.mode === 1) {
    if (failInfo.value.validFlag === 0) {
      return t('表格导入中')
    }
    if (failInfo.value.validFlag === 1 && failInfo.value.taskStatus === 1) {
      return t('订单创建中')
    }
    return t('表格导入创建订单')
  } else {
    if (failInfo.value.validFlag === 0) {
      return t('表格导入中')
    }
    if (failInfo.value.validFlag === 1 && failInfo.value.taskStatus === 1) {
      return t('商品创建中')
    }
    return t('表格导入创建商品')
  }
})

const sortList = (list: any) => {
  return list.sort((prev: any, next: any) => {
    return prev.rowNumber - next.rowNumber
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_button, {
      type: "primary",
      plain: false,
      class: "shopcart-upload-file",
      loading: isLoading.value,
      onClick: open
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(btnText)), 1)
      ]),
      _: 1
    }, 8, ["loading"]),
    _createVNode(CheckSet, {
      visible: checkSetVisible.value,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((checkSetVisible).value = $event)),
      set: setObj.value
    }, null, 8, ["visible", "set"]),
    _createVNode(UploadFileModal, {
      isCanUseOnTheWayStock: props.isCanUseOnTheWayStock,
      visible: uploadFileModalVisible.value,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((uploadFileModalVisible).value = $event)),
      mode: __props.mode,
      onSubmit: uploadSuccessCallback,
      onError: failCheckErrorCallback
    }, null, 8, ["isCanUseOnTheWayStock", "visible", "mode"]),
    _createVNode(UploadProgress, {
      failInfo: failInfo.value,
      mode: __props.mode
    }, null, 8, ["failInfo", "mode"]),
    _createVNode(UploadFail, {
      visible: uploadFailVisible.value,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((uploadFailVisible).value = $event)),
      failInfo: failInfo.value,
      onSuccess: _cache[3] || (_cache[3] = ($event: any) => (emits('success')))
    }, null, 8, ["visible", "failInfo"]),
    _createVNode(OpenMember, {
      ref: (_value, _refs) => {
        _refs['openMemberRef'] = _value
        openMemberRef.value = _value
      }
    }, null, 512),
    _createVNode(UploadFailTable, {
      visible: uploadFailTableVisible.value,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((uploadFailTableVisible).value = $event)),
      list: errorList.value,
      type: tableFailType.value,
      taskId: taskId.value,
      taskType: taskType.value
    }, null, 8, ["visible", "list", "type", "taskId", "taskType"])
  ], 64))
}
}

})